var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFramevehicle4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_63976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4321 15.3824L26.7052 11.2507C26.1689 9.95998 24.9076 9.12305 23.5107 9.12305H4.01367C2.63449 9.12305 1.51465 10.2429 1.51465 11.6221V18.795C1.51465 19.1663 1.81524 19.461 2.18066 19.461H27.8192C28.1905 19.461 28.4852 19.1604 28.4852 18.795V15.6417C28.4852 15.5533 28.4675 15.4649 28.4321 15.3824Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4321 15.3824L26.7052 11.2507C26.1689 9.95998 24.9076 9.12305 23.5107 9.12305H4.01367C2.63449 9.12305 1.51465 10.2429 1.51465 11.6221V12.0582C1.51465 10.679 2.63449 9.5592 4.01367 9.5592H23.5048C24.9017 9.5592 26.163 10.3961 26.6993 11.6869L28.4262 15.8185C28.4616 15.901 28.4793 15.9894 28.4793 16.0779V15.6417C28.4852 15.5533 28.4675 15.4649 28.4321 15.3824Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51465 18.7246V18.7894C1.51465 19.1608 1.81524 19.4555 2.18066 19.4555H27.8192C28.1905 19.4555 28.4852 19.1549 28.4852 18.7894V18.7246H1.51465Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51468 16.3435H28.4852V15.6422C28.4852 15.5538 28.4675 15.4654 28.4322 15.3828L28.1493 14.7109H1.50879V16.3435H1.51468Z",
    fill: "#4B5AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.892 10.3379H6.83105V14.4459H10.892V10.3379Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.45 10.3379H11.4048V14.4459H22.45V10.3379Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3241 10.3379H3.01761C2.69345 10.3379 2.42822 10.6031 2.42822 10.9273V13.8566C2.42822 14.1807 2.69345 14.4459 3.01761 14.4459H6.3241V10.3379Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3868 11.6817C26.0154 10.8683 25.2021 10.3379 24.3062 10.3379H22.9624V11.6817H26.3868Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5243 14.4458L26.5283 12.0234H22.9565V14.4458H24.1353L25.4438 15.9547C25.4438 15.9547 26.8171 15.9547 27.4064 15.9547C27.9958 15.9547 27.5243 14.4458 27.5243 14.4458Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2493 10.9746H15.6128V19.1613H19.2493V10.9746Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3693 11.127H15.7661V19.0071H17.3693V11.127Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0963 11.127H17.4932V19.0071H19.0963V11.127Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7917 19.1256C10.7917 17.9645 9.84872 17.0215 8.68762 17.0215C7.52652 17.0215 6.5835 17.9645 6.5835 19.1256C6.5835 19.2376 6.59528 19.3496 6.61297 19.4616H10.7682C10.78 19.3496 10.7917 19.2435 10.7917 19.1256Z",
    fill: "#02050C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9094 19.1256C25.9094 17.9645 24.9664 17.0215 23.8053 17.0215C22.6442 17.0215 21.7012 17.9645 21.7012 19.1256C21.7012 19.2376 21.713 19.3496 21.7306 19.4616H25.8858C25.8976 19.3496 25.9094 19.2435 25.9094 19.1256Z",
    fill: "#02050C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68164 20.876C9.64841 20.876 10.4321 20.0923 10.4321 19.1255C10.4321 18.1587 9.64841 17.375 8.68164 17.375C7.71487 17.375 6.93115 18.1587 6.93115 19.1255C6.93115 20.0923 7.71487 20.876 8.68164 20.876Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68182 20.1566C9.25147 20.1566 9.71326 19.6948 9.71326 19.1252C9.71326 18.5555 9.25147 18.0938 8.68182 18.0938C8.11218 18.0938 7.65039 18.5555 7.65039 19.1252C7.65039 19.6948 8.11218 20.1566 8.68182 20.1566Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68153 19.7732C9.0396 19.7732 9.32986 19.483 9.32986 19.1249C9.32986 18.7668 9.0396 18.4766 8.68153 18.4766C8.32347 18.4766 8.0332 18.7668 8.0332 19.1249C8.0332 19.483 8.32347 19.7732 8.68153 19.7732Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.682 19.5222C8.90009 19.5222 9.07689 19.3454 9.07689 19.1273C9.07689 18.9092 8.90009 18.7324 8.682 18.7324C8.46391 18.7324 8.28711 18.9092 8.28711 19.1273C8.28711 19.3454 8.46391 19.5222 8.682 19.5222Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68188 18.3958C8.75024 18.3958 8.80565 18.3483 8.80565 18.2897C8.80565 18.2311 8.75024 18.1836 8.68188 18.1836C8.61352 18.1836 8.55811 18.2311 8.55811 18.2897C8.55811 18.3483 8.61352 18.3958 8.68188 18.3958Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68188 20.0755C8.75024 20.0755 8.80565 20.028 8.80565 19.9694C8.80565 19.9108 8.75024 19.8633 8.68188 19.8633C8.61352 19.8633 8.55811 19.9108 8.55811 19.9694C8.55811 20.028 8.61352 20.0755 8.68188 20.0755Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52455 19.2495C9.58314 19.2495 9.63064 19.1941 9.63064 19.1257C9.63064 19.0574 9.58314 19.002 9.52455 19.002C9.46596 19.002 9.41846 19.0574 9.41846 19.1257C9.41846 19.1941 9.46596 19.2495 9.52455 19.2495Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84486 19.2495C7.90345 19.2495 7.95095 19.1941 7.95095 19.1257C7.95095 19.0574 7.90345 19.002 7.84486 19.002C7.78627 19.002 7.73877 19.0574 7.73877 19.1257C7.73877 19.1941 7.78627 19.2495 7.84486 19.2495Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36724 18.6176C9.40867 18.5762 9.40308 18.5034 9.35474 18.4551C9.3064 18.4067 9.23363 18.4011 9.1922 18.4426C9.15077 18.484 9.15637 18.5568 9.20471 18.6051C9.25304 18.6534 9.32581 18.659 9.36724 18.6176Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18023 19.811C8.22166 19.7695 8.21606 19.6968 8.16773 19.6484C8.11939 19.6001 8.04662 19.5945 8.00519 19.6359C7.96376 19.6774 7.96936 19.7501 8.0177 19.7985C8.06603 19.8468 8.1388 19.8524 8.18023 19.811Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19438 19.8086C9.2358 19.8501 9.30857 19.8445 9.35691 19.7962C9.40526 19.7478 9.41086 19.6751 9.36944 19.6336C9.32802 19.5922 9.25524 19.5978 9.2069 19.6461C9.15856 19.6944 9.15295 19.7672 9.19438 19.8086Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00199 18.6231C8.04342 18.6645 8.11619 18.6589 8.16453 18.6106C8.21287 18.5623 8.21848 18.4895 8.17706 18.4481C8.13563 18.4066 8.06286 18.4122 8.01452 18.4606C7.96618 18.5089 7.96057 18.5817 8.00199 18.6231Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 20.876C24.7666 20.876 25.5503 20.0923 25.5503 19.1255C25.5503 18.1587 24.7666 17.375 23.7998 17.375C22.833 17.375 22.0493 18.1587 22.0493 19.1255C22.0493 20.0923 22.833 20.876 23.7998 20.876Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7995 20.1566C24.3691 20.1566 24.8309 19.6948 24.8309 19.1252C24.8309 18.5555 24.3691 18.0938 23.7995 18.0938C23.2299 18.0938 22.7681 18.5555 22.7681 19.1252C22.7681 19.6948 23.2299 20.1566 23.7995 20.1566Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7997 19.7732C24.1578 19.7732 24.448 19.483 24.448 19.1249C24.448 18.7668 24.1578 18.4766 23.7997 18.4766C23.4416 18.4766 23.1514 18.7668 23.1514 19.1249C23.1514 19.483 23.4416 19.7732 23.7997 19.7732Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7997 19.5222C24.0178 19.5222 24.1946 19.3454 24.1946 19.1273C24.1946 18.9092 24.0178 18.7324 23.7997 18.7324C23.5816 18.7324 23.4048 18.9092 23.4048 19.1273C23.4048 19.3454 23.5816 19.5222 23.7997 19.5222Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7996 18.3958C23.8679 18.3958 23.9233 18.3483 23.9233 18.2897C23.9233 18.2311 23.8679 18.1836 23.7996 18.1836C23.7312 18.1836 23.6758 18.2311 23.6758 18.2897C23.6758 18.3483 23.7312 18.3958 23.7996 18.3958Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7996 20.0755C23.8679 20.0755 23.9233 20.028 23.9233 19.9694C23.9233 19.9108 23.8679 19.8633 23.7996 19.8633C23.7312 19.8633 23.6758 19.9108 23.6758 19.9694C23.6758 20.028 23.7312 20.0755 23.7996 20.0755Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6422 19.2495C24.7008 19.2495 24.7483 19.1941 24.7483 19.1257C24.7483 19.0574 24.7008 19.002 24.6422 19.002C24.5836 19.002 24.5361 19.0574 24.5361 19.1257C24.5361 19.1941 24.5836 19.2495 24.6422 19.2495Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9625 19.2495C23.0211 19.2495 23.0686 19.1941 23.0686 19.1257C23.0686 19.0574 23.0211 19.002 22.9625 19.002C22.9039 19.002 22.8564 19.0574 22.8564 19.1257C22.8564 19.1941 22.9039 19.2495 22.9625 19.2495Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4849 18.6176C24.5264 18.5762 24.5208 18.5034 24.4724 18.4551C24.4241 18.4067 24.3513 18.4011 24.3099 18.4426C24.2685 18.484 24.274 18.5568 24.3224 18.6051C24.3707 18.6534 24.4435 18.659 24.4849 18.6176Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.294 19.8071C23.3354 19.7656 23.3298 19.6929 23.2815 19.6445C23.2332 19.5962 23.1604 19.5906 23.119 19.632C23.0775 19.6734 23.0831 19.7462 23.1315 19.7946C23.1798 19.8429 23.2526 19.8485 23.294 19.8071Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3101 19.8086C24.3515 19.8501 24.4243 19.8445 24.4726 19.7962C24.521 19.7478 24.5266 19.6751 24.4852 19.6336C24.4437 19.5922 24.371 19.5978 24.3226 19.6461C24.2743 19.6944 24.2687 19.7672 24.3101 19.8086Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1216 18.6192C23.163 18.6606 23.2358 18.655 23.2842 18.6067C23.3325 18.5584 23.3381 18.4856 23.2967 18.4442C23.2553 18.4027 23.1825 18.4083 23.1341 18.4566C23.0858 18.505 23.0802 18.5777 23.1216 18.6192Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1868 11.5645H16.061V14.8533H17.1868V11.5645Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8015 11.5645H17.6758V14.8533H18.8015V11.5645Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5244 14.4453L25.6325 15.7538H27.212C27.212 15.7538 27.4949 15.6123 27.4006 15.0995C27.3063 14.5868 27.1531 14.4453 27.1531 14.4453H24.5244Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4851 16.5391H27.7012V18.0951H28.4851V16.5391Z",
    fill: "#FBD303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2493 10.3379H15.6128V11.1277H19.2493V10.3379Z",
    fill: "#393D47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_63976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramevehicle4);
export default __webpack_public_path__ + "static/media/Framevehicle4.e7c754281fe657ecef5c76bfaf164703.svg";
export { ForwardRef as ReactComponent };